module.exports = __webpack_public_path__ + "static/Damien-96750f0a5c946326e7b26e528c9ffacf.png";